const isDev =
    (import.meta as any).env?.MODE === 'development' ||
    process.env.NODE_ENV === 'development';

/**
 * Debug-only logs (removed or silent in prod)
 */
export const log = (...args: unknown[]): void => {
    if (isDev) {
        console.log(...args);
    }
};

export const warn = (...args: unknown[]): void => {
    if (isDev) {
        console.warn(...args);
    }
};

/**
 * Errors are usually kept in prod
 */
export const error = (...args: unknown[]): void => {
    console.error(...args);
};
